import clsx from "clsx";
import React from "react";
import { Option } from "web/react/components/select/types";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./multi-column-option.module.css";

export interface MultiColumnOptionProps {
    className?: string;
    isSelected: boolean;
    option: Option;
    onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export default function MultiColumnOption({
    className,
    isSelected,
    option,
    onClick,
}: MultiColumnOptionProps): JSX.Element {
    const nColumns = option.text.length;

    const optionText: JSX.Element = (
        <>
            {option.text.map((text, index) => {
                // testing explicitly for bool, not null, undefined, etc
                const outOfStock = option.value.in_stock === false;
                const showAlertMe = index !== 0 && outOfStock;

                // i18n instance is "Alert Me"
                const textToDisplay = showAlertMe
                    ? gettext("product.buy_area.alert_me_size.label")
                    : text;
                return (
                    <div
                        className={clsx(styles.optionText, {
                            [styles.alertMe]: showAlertMe,
                        })}
                        key={`${text}_${index}`}
                    >
                        {textToDisplay}
                    </div>
                );
            })}
        </>
    );

    return (
        <div
            aria-label={"size option"}
            aria-description={option.selectedText}
            data-test-id={"multiColumnOption"}
            onClick={onClick}
            className={clsx(
                styles.option,
                { [styles.centered]: nColumns === 1 },
                { [styles.selected]: isSelected && !option.disabled },
                { [styles.disabled]: option.disabled },
                className
            )}
        >
            {optionText}
        </div>
    );
}
